import { makeStyles } from "@material-ui/core/styles";

const AutocompleteStyles = makeStyles((theme) => ({
    inputRoot: {
        '& .MuiInputBase-input:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 30px ${theme.palette.background.paper} inset`,
            WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        },
    },
}));

export {
    AutocompleteStyles
}
